import { Logo } from "assets/icons/Logo";
import { WalletMenu } from "components/WalletMenu";
import { ROUTES } from "constants.routes";
import { NavLink } from "react-router-dom";
import "./styles.css";
import { usePrivy } from "@privy-io/react-auth";

export function Header() {
  const { user } = usePrivy();

  const userName = user?.twitter?.username;

  return (
    <header className="flex items-center px-5 py-4">
      <div className="mr-auto gap-3 font-pixel text-3xl flex items-center">
        <Logo /> AGNT.Connect
      </div>

      {userName && (
        <nav className="flex items-center gap-[3.125rem] ml-auto mr-6">
          <NavLink
            to={ROUTES.HOME}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            Home
          </NavLink>
          <NavLink
            to={ROUTES.CAMPAIGNS}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            Campaigns
          </NavLink>

          <NavLink
            to={ROUTES.DAPPS}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            dApps
          </NavLink>

          <NavLink
            to={ROUTES.NEWS}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            News
          </NavLink>

          <NavLink
            to={ROUTES.PROJECTS}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            Projects
          </NavLink>

          <NavLink
            to={ROUTES.ASSOCIATED_TOKENS}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            Tokens
          </NavLink>

          <NavLink
            to={ROUTES.SUGGESTIONS}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            Suggestions
          </NavLink>

          <NavLink
            to={ROUTES.LEARN_EARN}
            end
            className="text-white text-sm font-medium header-nav-item"
          >
            Learn & Earn
          </NavLink>
        </nav>
      )}

      <WalletMenu />

      {/* <HeaderMobileMenu /> */}
    </header>
  );
}
